import React from 'react';
import '../sass/pages/_cards.scss';

const Cards = ({ id, title, cover, alt }) => {
    return (
        <div className='card'>
            <div className="card-boxe">
                <img src={cover} alt={alt} />
                <div className="card-text">
                    <h4>{title}</h4>
                </div>
            </div>
        </div>
    )
}

export default Cards